// This file has to be imported at least once to make sure all models are initialized

export { default as Sale } from "./sale";
export { default as Contact } from "./contact";
export { default as ContactAddress } from "./contact-address";
export { default as ContactGroup } from "./contact-group";
export { default as ContactExtraFields } from "./contact-extra-fields";
export { default as FrequencyDocument } from "./frequency-document";
export { default as Product } from "./product";
export { default as ProductExtraFields } from "./product-extra-fields";
export { default as ProductImage } from "./product-image";
export { default as ProductStock } from "./product-stock";
export { default as ProductWriteOffRow } from "./product-write-off-row";
export { default as ProductCompositionRow } from "./product-composition-row";
export { default as Vat } from "./vat";
export { default as StockIn }  from "./stock-in";
export { default as SaleType } from "./sale-type";
export { default as SaleRow } from "./sale-row";
export { default as SaleExtraFields } from "./sale-extra-fields";
export { default as SaleHistory } from "./sale-history";
export { default as Bank } from "./bank";
export { default as Crm } from "../crm/crm";
export { default as Car } from "./car";
export { default as BankType } from "./bank-type";
export { default as Purchase } from "./purchase";
export { default as Project } from "./project";
export { ProductTrackingNumber } from "./product-tracking-number";
export { default as SizeTable } from "./size-table";
export { default as SizeTableEntry } from "./size-table-entry";
export { ProductSizeStock } from "./product-size-stock";
export { ProductSizeBarcode } from "./product-size-barcode";
export { ProductPriceCategorySalesDates } from "./product-price-category-sales-dates";
export { DiverseLedger } from "./diverse-ledger";
export { FixedAsset } from "./fixed-asset";
export { SaleHistoryEventType } from "./sale-history";
export { FrequencyType } from "./frequency-document";
export { AwsDocument } from "./aws-document";
export { ContactPeppolEndpoint as PeppolEndpoint } from "./contact-peppol-endpoint";